module.exports = __webpack_public_path__ + "static/media/14UNEP18.fd4ef1a3.jpg";